
import {useLocation} from "react-router-dom";
import {useNavigate} from "react-router";
//import {useHeaderScroll} from "../../hooks/useHeaderScroll.ts";

export default function Header() {
    const navigate = useNavigate();
    const location = useLocation();

    return (
        <div id="vc_header">

            <div className="vc_section">
                <div className="header_wrapper">
                    <div className="header_left">
                        <h1 className="header_title">Verifiable Credentials Ecosystem</h1>
                        <h2 className="header_subtitle">by MyNextID</h2>
                    </div>

                    <div className="contain_image" >
                        <a href="mailto:info@netis.si">
                            <svg fill="#000000" width="30px" height="30px" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg">
                                <path d="M16.015 18.861l-4.072-3.343-8.862 10.463h25.876l-8.863-10.567-4.079 3.447zM29.926 6.019h-27.815l13.908 11.698 13.907-11.698zM20.705 14.887l9.291 11.084v-18.952l-9.291 7.868zM2.004 7.019v18.952l9.291-11.084-9.291-7.868z"></path>
                            </svg>
                        </a>
                    </div>
                    
                </div>
            </div>
        </div>
    )
}
